/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import logo from '../../assets/Kognitos-logo.png';

export default function NameWithLogoIcon() {
  return <img src={logo} alt="logo" />;
}
